import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import TicketModal from "../../components/ticket/TicketModal";
import "../../components/app/Fixes.css";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {
  useTelephonyTicketPaginationQuery,
  useTicketPaginationQuery,
  useTicketWorkflowByAssigneeQuery,
  useUserTicketQuery,
} from "../../Services/ticket/TicketList";
import LoadingSpinner from "../../components/LoadingSpinner";
import BulkAssigneeModal from "../../components/ticket/BulkAssigneeModal";
import { toast } from "react-toastify";
import TicketFilterModal from "../../components/ticket/TicketFilterModal";
import TicketStandardView from "./TicketStandardView";
import TicketListView from "./TicketListView";
import TicketCardView from "./TicketCardView";
import { useMeeQuery } from "../../Services/settingsAPIs/CommonAPI";
import { INCOMING_CALL } from "../../constants";
import { useNavigate } from "react-router-dom";
import BulkStatusModal from "../../components/ticket/BulkStatusModal";
import "./TicketList.scss";
import { useUpdateTicketWorkflowMutation } from "../../Services/ticket/CreateTicket";
import NonActionableModal from "./NonActionableModal";

const TicketLists = () => {
  const storedOption =
    sessionStorage.getItem("selectedOption") || "ticketListView";
  const [selectedOption, setSelectedOption] = useState(storedOption);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkAssigneeModalOpen, setIsBulkAssigneeModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<any>(() => {
    const savedPage = sessionStorage.getItem("ticketCurrentPage");
    return savedPage ? Number(savedPage) : 1;
  });
  const [selectedTickets, setSelectedTickets] = useState<string[]>([]);
  const [liftingKey, setLiftingKey] = useState([]);
  const [isFilterModalOpen, setFilterIsModalOpen] = useState(false);
  const [isTicketLoading, setIsTicketLoading] = useState<boolean>(false);
  const [isBulkStatusModalOpen, setIsBulkStatusModalOpen] = useState(false);

  // ── Non-actionable modal open state ─
  const [isNonActionableModalOpen, setIsNonActionableModalOpen] =
    useState(false);

  const getChannelForView = (view: string) => {
    return sessionStorage.getItem(`channel_${view}`) || "";
  };

  const [channel, setChannel] = useState(
    sessionStorage.getItem(`channel_${selectedOption}`) || "All",
  );
  const { data: useData } = useMeeQuery({});

  const userRole = localStorage.getItem("user_role");
  const ticketChannel = [
    { label: "Phone", key: "Phone" },
    { label: "Inbound Call", key: "inbound_phone" },
    { label: "Outbound Call", key: "outbound_phone" },
    { label: "App", key: "app" },
    { label: "Email", key: "email" },
    { label: "Chat", key: "Chat" },
    { label: "Social media", key: "Social-Media" },
    { label: "Whatsapp", key: "Whatsapp" },
    { value: "Facebook", label: "Facebook" },
    { label: "Walk-in", key: "Walk-in"}
  ];

  const apiChannelKey = channel === "All" ? "" : channel;

  const teamIdFromLocalStorage = localStorage.getItem("teamId");
  const { data: Ticket } = useUserTicketQuery(teamIdFromLocalStorage);

  const [selectedWorkFlow, setselectedWorkFlow] = useState(
    sessionStorage.getItem("selectedWorkFlow") || "",
  );
  const [data, setData] = useState<any>();
  const [selectedTeamId, setSelectedTeamId] = useState(() => {
    const selectedTeamIdFromSession = sessionStorage.getItem("selectedTeamId");
    const userRole = localStorage.getItem("user_role");
    const userId = localStorage.getItem("User_Id");
    if (selectedTeamIdFromSession) return selectedTeamIdFromSession;
    if (userRole === "admin") return "My Team";
    if (userRole === "agent" || userRole === "manager") return userId;
    return null;
  });

  const [isLoadingPageChange, setIsLoadingPageChange] =
    useState<boolean>(false);
  const [liftUiData, setLiftUiData] = useState(0);
  const [value, setValue] = useState(() => {
    return sessionStorage.getItem("ticketTabValue") || "All";
  });
  const [storeKey, setStoreKey] = useState(() => {
    return sessionStorage.getItem("storeKey") || "All";
  });
  const [storingTicketData, setStoringTicketData] = useState("");
  const [selectedFilterAndValue, setSelectedFilterAndValue] = useState<any>({
    action__contact__email__icontains: "",
    action__assignee__username__icontains: "",
    title__icontains: "",
    created: "",
    id__icontains: "",
    merchant_id: "",
  });
  const [selectedFilterAndValue1, setSelectedFilterAndValue1] = useState<any>(
    () => {
      const sessionData = sessionStorage.getItem("selectedFilterAndValue");
      return sessionData
        ? JSON.parse(sessionData)
        : {
            action__contact__email__icontains: "",
            action__assignee__username__icontains: "",
            title__icontains: "",
            created: "",
            id__icontains: "",
            merchant_id: "",
          };
    },
  );

  const {
    data: ticketWorkflow,
    refetch: refetchWorkflow,
    status,
  } = useTicketWorkflowByAssigneeQuery(
    {
      selectedWorkFlow,
      selectedFilterAndValue1,
      selectedTeamId,
      channel: apiChannelKey,
    },
    {
      skip: !selectedWorkFlow,
      refetchOnMountOrArgChange: 60,
    },
  );

  const callActive = localStorage.getItem(INCOMING_CALL) === "true";
  const mobileNumber = localStorage.getItem("liftingMobileNumber");

  // Non-actionable
  const [triggerUpdateTicket] = useUpdateTicketWorkflowMutation();
  const [nonActionablePending, setNonActionablePending] = useState(false);

  const handleNonActionable = async (
    ticketId: string | number,
    currentValue: boolean,
  ) => {
    setNonActionablePending(true);
    try {
      const response = await triggerUpdateTicket({
        id: ticketId,
        body: { is_non_actionable: !currentValue },
      });
      if (response?.data) {
        const isCallActive = localStorage.getItem(INCOMING_CALL) === "true";
        if (isCallActive) {
          telephonyRefetch();
        } else {
          refetch();
        }
        toast.success(
          !currentValue
            ? "Ticket marked as non-actionable"
            : "Ticket marked as actionable",
        );
      } else if (response?.error) {
        toast.error("Unable to update non-actionable status");
      }
    } catch {
      toast.error("An error occurred while updating non-actionable status");
    } finally {
      setNonActionablePending(false);
    }
  };

  const handleNonActionableToggled = () => {
    const isCallActive = localStorage.getItem(INCOMING_CALL) === "true";
    if (isCallActive) {
      telephonyRefetch();
    } else {
      refetch();
    }
  };

  const [listViewPageSize, setListViewPageSize] = useState<number>(() => {
    const savedPageSize = sessionStorage.getItem("ticketListViewPageSize");
    return savedPageSize ? Number(savedPageSize) : 50;
  });

  const [standardViewPageSize, setStandardViewPageSize] = useState<number>(
    () => {
      const savedPageSize = sessionStorage.getItem(
        "ticketStandardViewPageSize",
      );
      return savedPageSize ? Number(savedPageSize) : 50;
    },
  );

  const [cardViewPageSize, setCardViewPageSize] = useState<number>(() => {
    const savedPageSize = sessionStorage.getItem("ticketCardViewPageSize");
    return savedPageSize ? Number(savedPageSize) : 50;
  });

  const getCurrentPageSize = () => {
    switch (selectedOption) {
      case "ticketListView":
        return listViewPageSize;
      case "ticketStandardView":
        return standardViewPageSize;
      case "ticketCardView":
        return cardViewPageSize;
      default:
        return 50;
    }
  };

  const handlePageChange = (page: number, size: number) => {
    setCurrentPage(page);
    switch (selectedOption) {
      case "ticketListView":
        setListViewPageSize(size);
        sessionStorage.setItem("ticketListViewPageSize", size.toString());
        break;
      case "ticketStandardView":
        setStandardViewPageSize(size);
        sessionStorage.setItem("ticketStandardViewPageSize", size.toString());
        break;
      case "ticketCardView":
        setCardViewPageSize(size);
        sessionStorage.setItem("ticketCardViewPageSize", size.toString());
        break;
    }
    sessionStorage.setItem("ticketCurrentPage", page.toString());
    if (callActive) {
      telephonyRefetch();
    } else {
      refetch();
    }
  };

  const {
    data: fetchedData,
    refetch,
    status: ticketStatus,
  } = useTicketPaginationQuery(
    {
      currentPage,
      pageSize: getCurrentPageSize(),
      value,
      selectedWorkFlow,
      selectedTeamId,
      selectedFilterAndValue1,
      liftingKey,
      storeKey,
      channel: apiChannelKey,
    },
    {
      skip: !selectedWorkFlow || callActive,
      refetchOnMountOrArgChange: 60,
    },
  );

  const {
    data: fetchedTelephonyData,
    refetch: telephonyRefetch,
    status: telephonyStatus,
  } = useTelephonyTicketPaginationQuery(
    {
      currentPage,
      value,
      selectedWorkFlow,
      selectedTeamId,
      selectedFilterAndValue1,
      liftingKey,
      storeKey,
      mobileNumber,
    },
    {
      skip: !callActive || !selectedWorkFlow,
      refetchOnMountOrArgChange: 60,
    },
  );

  useEffect(() => {
    sessionStorage.setItem("storeKey", storeKey);
  }, [storeKey]);
  useEffect(() => {
    sessionStorage.setItem("ticketTabValue", value);
  }, [value]);
  useEffect(() => {
    sessionStorage.setItem(`channel_${selectedOption}`, channel);
  }, [channel, selectedOption]);

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "850px",
      height: "80%",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };
  const customModalStyles1 = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "450px",
    },
  };
  const customFilterModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "50px",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openFilterModal = () => setFilterIsModalOpen(true);
  const closeFilterModal = () => setFilterIsModalOpen(false);

  const openBulkModal = () => {
    if (selectedTickets.length === 0)
      return toast.error("Please select ticket.");
    setIsBulkAssigneeModalOpen(true);
  };
  const closeBulkModal = () => {
    setSelectedTickets([]);
    setIsBulkAssigneeModalOpen(false);
  };

  const openBulkStatusModal = () => {
    if (selectedTickets.length === 0)
      return toast.error("Please select ticket.");
    setIsBulkStatusModalOpen(true);
  };
  const closeBulkStatusModal = () => {
    setSelectedTickets([]);
    setIsBulkStatusModalOpen(false);
  };

  const handleDropdownChange = (event) => {
    const selected = event.target.value;
    sessionStorage.setItem(`channel_${selectedOption}`, channel);
    setSelectedOption(selected);
    setSelectedTickets([]);
    sessionStorage.setItem("selectedOption", selected);
    setChannel(getChannelForView(selected));
  };

  const handleWorkflowChange = (event) => {
    setCurrentPage(1);
    setselectedWorkFlow(event.target.value);
    sessionStorage.setItem("selectedWorkFlow", event.target.value);
    setValue("All");
    setStoreKey("All");
    sessionStorage.setItem("ticketTabValue", "All");
    sessionStorage.setItem("storeKey", "All");
  };

  useEffect(() => {
    const storedWorkFlow = sessionStorage.getItem("selectedWorkFlow");
    if (storedWorkFlow) setselectedWorkFlow(storedWorkFlow);
  }, [selectedWorkFlow]);

  const handleTeamChange = (e) => {
    const id = e.target.value;
    setSelectedTeamId(id);
    sessionStorage.setItem("ticketCurrentPage", "1");
    sessionStorage.setItem("selectedTeamId", id);
    setIsLoadingPageChange(true);
  };

  useEffect(() => {
    const storedTeamId = localStorage.getItem("selectedTeamId");
    if (storedTeamId) setSelectedTeamId(storedTeamId);
  }, []);

  useEffect(() => {
    setIsLoadingPageChange(true);
    if (callActive) {
      if (fetchedTelephonyData?.results) setData(fetchedTelephonyData?.results);
    } else {
      if (fetchedData?.results) setData(fetchedData?.results);
    }
    setIsLoadingPageChange(false);
  }, [fetchedData, callActive, fetchedTelephonyData]);

  useEffect(() => {
    if (callActive) {
      if (fetchedTelephonyData) {
        setIsLoadingPageChange(true);
        setData(fetchedTelephonyData);
        setIsLoadingPageChange(false);
      }
    } else {
      if (fetchedData) {
        setIsLoadingPageChange(true);
        setData(fetchedData);
        setIsLoadingPageChange(false);
      }
    }
  }, [callActive, fetchedData, fetchedTelephonyData]);

  useEffect(() => {
    const setDispositionData = data?.results?.reduce(
      (acc: any, disposition: any) => {
        const dispositionId = disposition?.action?.disposition?.id;
        if (dispositionId) acc[disposition?.id] = dispositionId;
        return acc;
      },
      {},
    );
    setStoringTicketData(setDispositionData || "");
  }, [data]);

  const handleSubmit = (filterValues) => {
    setIsLoadingPageChange(true);
    setSelectedFilterAndValue1(filterValues);
    setIsLoadingPageChange(false);
  };

  useEffect(() => {
    if (Ticket && Ticket?.results?.length > 0) {
      const firstWorkflowId = Ticket?.results[0]?.id;
      if (!selectedWorkFlow) {
        setselectedWorkFlow(firstWorkflowId);
        sessionStorage.setItem("selectedWorkFlow", firstWorkflowId);
      }
    }
  }, [Ticket]);

  useEffect(() => {
    const savedPage = sessionStorage.getItem("ticketCurrentPage");
    if (savedPage !== currentPage.toString())
      sessionStorage.setItem("ticketCurrentPage", currentPage.toString());
  }, [currentPage]);

  useEffect(() => {
    if (ticketStatus === "pending" || telephonyStatus === "pending") {
      setIsTicketLoading(true);
    } else {
      setIsTicketLoading(false);
    }
  }, [ticketStatus, telephonyStatus]);

  const navigate = useNavigate();
  const handleBackButtonClick = () => navigate(-1);
  const taskHandler = () => navigate("/ticket/tasks");
  const channelSelectHandler = (e) => setChannel(e.target.value);

  return (
    <div className="ticket-list-info-container">
      <div className="ticket-info-wrapper">
        {nonActionablePending && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 9999,
              backgroundColor: "rgba(255, 255, 255, 0.55)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "wait",
            }}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <LoadingSpinner />
          </div>
        )}

        {/* Page Title */}
        <div className="page-title-section">
          <button
            className="back-button"
            onClick={handleBackButtonClick}
            aria-label="Go back"
          >
            <i className="bi bi-arrow-left"></i>
          </button>
          <h1 className="page-title">Ticket</h1>
        </div>

        {/* Filter Bar */}
        <div className="filter-bar">
          <div className="filter-left">
            <FormControl className="filter-select">
              <InputLabel id="assignee-select-label">
                Select assignee
              </InputLabel>
              <Select
                labelId="assignee-select-label"
                value={selectedTeamId}
                onChange={handleTeamChange}
                label="Select assignee"
              >
                <MenuItem value="My Team">My Team</MenuItem>
                <MenuItem value={localStorage.getItem("User_Id")}>
                  Self
                </MenuItem>
              </Select>
            </FormControl>

            <FormControl className="filter-select">
              <InputLabel id="channel-select-label">Channel</InputLabel>
              <Select
                labelId="channel-select-label"
                onChange={channelSelectHandler}
                value={channel}
                label="Channel"
              >
                <MenuItem value="All" selected>
                  All
                </MenuItem>
                {ticketChannel?.map((el, index) => (
                  <MenuItem key={index} value={el?.key}>
                    {el?.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl className="filter-select">
              <InputLabel id="workflow-select-label">
                Select Workflow
              </InputLabel>
              <Select
                labelId="workflow-select-label"
                value={selectedWorkFlow}
                onChange={handleWorkflowChange}
                label="Select Workflow"
              >
                {Ticket &&
                  Ticket.results.map((workflow) => (
                    <MenuItem key={workflow.id} value={workflow.id}>
                      {workflow.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            <FormControl className="filter-select">
              <InputLabel id="view-select-label">View</InputLabel>
              <Select
                labelId="view-select-label"
                value={selectedOption}
                onChange={handleDropdownChange}
                label="View"
              >
                <MenuItem value="ticketListView">List View</MenuItem>
                <MenuItem value="ticketStandardView">Standard View</MenuItem>
                <MenuItem value="ticketCardView">Card View</MenuItem>
              </Select>
            </FormControl>

            <Button
              variant="outlined"
              className="filter-button"
              onClick={openFilterModal}
            >
              <i className="bi bi-filter" />
              <span>Search filter</span>
            </Button>
          </div>

          <div className="filter-right">
            <div
              className="icon-button"
              onClick={openBulkModal}
              title="Assignee"
            >
              <i className="bi bi-person-fill" />
            </div>

            {/* Non-Actionable button */}
            <Button
              variant="outlined"
              className="action-button"
              onClick={() => setIsNonActionableModalOpen(true)}
              title="View non-actionable tickets"
              disabled={!selectedWorkFlow}
            >
              <i className="bi bi-ticket-perforated fs-2" />
              <span>Non Actionable</span>
            </Button>

            {(userRole === "admin" || userRole === "manager") && (
              <Button
                variant="outlined"
                className="action-button"
                onClick={openBulkStatusModal}
                title="Change status"
              >
                <i className="bi bi-arrow-left-right" />
                <span>Change status</span>
              </Button>
            )}

            <Button
              variant="outlined"
              className="action-button"
              onClick={taskHandler}
              disabled
              style={{ opacity: 0.5, cursor: "not-allowed" }}
            >
              <i className="bi bi-list-task" />
              <span>Tasks</span>
            </Button>

            <Button
              variant="contained"
              className="primary-button"
              onClick={openModal}
            >
              <i className="bi bi-plus-lg text-white" />
              <span>Ticket</span>
            </Button>
          </div>
        </div>

        {/* Card Body */}
        <div className="card-body-ticket-list">
          {isLoadingPageChange ? (
            <div className="d-flex justify-content-center align-items-center">
              <LoadingSpinner />
            </div>
          ) : (
            <>
              {selectedOption === "ticketListView" && (
                <TicketListView
                  ticket={data}
                  setCurrentPage={setCurrentPage}
                  selectedTickets={selectedTickets}
                  setSelectedTickets={setSelectedTickets}
                  ticketWorkflow={ticketWorkflow}
                  setValue={setValue}
                  value={value}
                  setStoreKey={setStoreKey}
                  currentPage={currentPage}
                  setLiftUiData={setLiftUiData}
                  storingTicketData={storingTicketData}
                  refetch={callActive ? telephonyRefetch : refetch}
                  useData={useData}
                  pageSize={listViewPageSize}
                  setPageSize={setListViewPageSize}
                  onPageChange={handlePageChange}
                  isTicketLoading={isTicketLoading}
                  onNonActionable={handleNonActionable}
                />
              )}
              {selectedOption === "ticketStandardView" && (
                <TicketStandardView
                  ticket={data}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  setSelectedTickets={setSelectedTickets}
                  selectedTickets={selectedTickets}
                  setStoreKey={setStoreKey}
                  useData={useData}
                  setValue={setValue}
                  ticketWorkflow={ticketWorkflow}
                  value={value}
                  pageSize={standardViewPageSize}
                  setPageSize={setStandardViewPageSize}
                  onPageChange={handlePageChange}
                  isTicketLoading={isTicketLoading}
                  onNonActionable={handleNonActionable}
                />
              )}
              {selectedOption === "ticketCardView" && (
                <TicketCardView
                  ticket={data}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  setSelectedTickets={setSelectedTickets}
                  selectedTickets={selectedTickets}
                  setValue={setValue}
                  ticketWorkflow={ticketWorkflow}
                  setStoreKey={setStoreKey}
                  value={value}
                  setLiftUiData={setLiftUiData}
                  pageSize={cardViewPageSize}
                  setPageSize={setCardViewPageSize}
                  onPageChange={handlePageChange}
                  isTicketLoading={isTicketLoading}
                  onNonActionable={handleNonActionable}
                />
              )}
            </>
          )}
        </div>

        {/*Non-Actionable Tickets Modal */}
        <NonActionableModal
          isOpen={isNonActionableModalOpen}
          onClose={() => setIsNonActionableModalOpen(false)}
          queryParams={{
            value,
            selectedWorkFlow,
            selectedTeamId,
            selectedFilterAndValue1,
            liftingKey,
            storeKey,
            channel: apiChannelKey,
          }}
          onTicketToggled={handleNonActionableToggled}
        />

        <ReactModal
          isOpen={isFilterModalOpen}
          onRequestClose={closeFilterModal}
          style={customFilterModalStyles}
          contentLabel="Ticket Filter Modal"
          shouldCloseOnOverlayClick={false}
        >
          <TicketFilterModal
            closeFilterModal={closeFilterModal}
            selectedFilterAndValue={selectedFilterAndValue}
            setSelectedFilterAndValue={setSelectedFilterAndValue}
            handleSubmit={handleSubmit}
            setIsLoadingPageChange={setIsLoadingPageChange}
          />
        </ReactModal>

        <ReactModal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          style={customModalStyles}
          shouldCloseOnOverlayClick={false}
          contentLabel="New Ticket"
        >
          <TicketModal
            closeModal={closeModal}
            setIsLoading={setIsLoading}
            refetch={callActive ? telephonyRefetch : refetch}
            refetchWorkflow={refetchWorkflow}
            selectedWorkflow={selectedWorkFlow}
          />
        </ReactModal>

        <ReactModal
          isOpen={isBulkAssigneeModalOpen}
          onRequestClose={closeBulkModal}
          style={customModalStyles1}
          contentLabel="Bulk Assignee"
          shouldCloseOnOverlayClick={false}
        >
          <BulkAssigneeModal
            closeBulkModal={closeBulkModal}
            selectedTickets={selectedTickets}
            refetch={callActive ? telephonyRefetch : refetch}
          />
        </ReactModal>

        <ReactModal
          isOpen={isBulkStatusModalOpen}
          onRequestClose={closeBulkStatusModal}
          style={customModalStyles1}
          contentLabel="Bulk Status Change"
          shouldCloseOnOverlayClick={false}
        >
          <BulkStatusModal
            closeBulkStatusModal={closeBulkStatusModal}
            selectedTickets={selectedTickets}
            refetch={callActive ? telephonyRefetch : refetch}
            dispositionId={data?.results?.[0]?.action?.disposition?.id}
          />
        </ReactModal>
      </div>
    </div>
  );
};

export default TicketLists;